"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var MultiProductCarousel_1 = require("../components/MultiProductCarousel/MultiProductCarousel");
var targetNode = document.querySelector('.multi-product-carousel-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(MultiProductCarousel_1.default, null), targetNode);
}
